import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/skupina";

export const fetchAnimalGroups = createAsyncThunk(
  "animal-group/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createAnimalGroup = createAsyncThunk(
  "animal-group",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const animalGroupSlice = createSlice({
  name: "animalGroup",
  initialState: {
    page: null,
    groups: [],
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnimalGroups.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
        state.groups = action.payload.content || action.payload || [];
      })
      .addCase(fetchAnimalGroups.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAnimalGroups.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createAnimalGroup.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createAnimalGroup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload?.output ?? action.payload;
      })
      .addCase(createAnimalGroup.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default animalGroupSlice.reducer;
